export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'serialName',
    align: 'left',
    minWidth: 200,
    title: '流水号名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'serialType',
    align: 'left',
    width: 120,
    title: '流水号类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'specialPrefix',
    align: 'left',
    width: 100,
    title: '特殊前缀',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'billPrefix',
    align: 'left',
    width: 100,
    title: '单据前缀',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'dateType',
    align: 'left',
    width: 170,
    title: '日期格式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'isAddType',
    align: 'center',
    width: 100,
    title: '增长方式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'numberLength',
    align: 'center',
    width: 100,
    title: '数字长度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totalLength',
    align: 'center',
    width: 100,
    title: '总长度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'currentNo',
    align: 'center',
    width: 100,
    title: '当前编号',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'serialDescription',
    align: 'left',
    minWidth: 250,
    title: '流水号说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'center',
    width: 100,
    title: '是否启用',
    slots: { default: 'status' },
  },
  {
    field: 'currentDate',
    align: 'left',
    width: 170,
    title: '流水号生成日期',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
